export default {
  nav: {
    home: '首页',
    about: '关于我们',
    scenic: '缤纷景区',
    contact: '投诉建议',
    guide: '导览图',
    qrcode: '二维码'
  },
  home: {
    buyTicket: '在线购票',
    welcome: '欢迎来到欢乐谷',
    description: '黄石欢乐谷是一个充满欢乐与刺激的主题乐园',
    vr: 'VR全景',
    scanXiaohongshu: '扫一扫关注小红书',
    scanWechat: '扫一扫关注公众号',
    scanWeibo: '扫一扫关注官方微博',
    scanDouyin: '扫一扫关注抖音号'
  },
  us: {
    title: '关于我们',
    businessHours: '营业时间',
    openingHours: '周一至周五（恐龙梦工厂）10:00-17:30<br>周六（恐龙梦工厂+恐龙秘境）10:00-21:00<br>周日（恐龙梦工厂+恐龙秘境）10:00-17:30<br>(特殊节日开放时间另行通知，请随时关注官方公告)',
    specialEvents: '精彩活动',
    specialEventsInfo: '龙腾盛世耀山河，火花之夜共团圆',
    hotline: '欢乐热线',
    address: '地址：黄石市经济技术开发区园博大道以南希尔顿花园酒店旁',
    traffic: '交通指引',
    location: '地理位置',
    companyIntro: '景区介绍',
    trafficAndHotel: '交通住宿',
    foodAndShopping: '美食购物',
    foodAndShoppingSections: {
      brandDining: {
        title: '品牌餐饮',
        content: '连锁品质遇见景区风景，安心滋味不期而遇'
      },
      themeDining: {
        title: '主题餐厅',
        content: '把山川风味端上桌，让每口都藏着景区的故事'
      },
      creativeGifts: {
        title: '文创礼品',
        content: '把景区的光影与风雅，酿成可带走的时光信物'
      },
      groceryStore: {
        title: '杂货铺',
        content: '一罐零食藏时光，半架杂货载温柔'
      },
      specialFood: {
        title: '特色美食',
        content: '咖啡的醇、面食的暖、小吃的香，在这里集齐舌尖盛宴'
      },
      foodCart: {
        title: '特色餐车',
        content: '车轮上的烟火气，一口咬下新鲜感'
      }
    },
    companyIntroText: '黄石华侨城恐龙奇域位于黄石市大冶湖畔，占地1583亩，总投资约30亿元。项目由黄石市国有资本投资集团有限公司与深圳华侨城文化旅游科技集团有限公司联合开发。\n黄石华侨城恐龙奇域由五大主题区域组成，包括：恐龙水世界、恐龙梦工厂、恐龙秘境、恐龙小镇、恐龙潮玩馆。其中，恐龙梦工厂和恐龙水世界是以恐龙为主题结合黄石本土文化IP的大型水陆主题乐园。园区拥有50余项国内外顶级大型户外机械和水上游乐设备、大型室内沉浸式数字体验设备、实景演出和剧场表演，以及各类小型演出和互动秀。\n从2021年7月一期"恐龙水世界"开园，到2024年6月"恐龙梦工厂"建成运营，黄石华侨城恐龙奇域年均接待游客超200万人次，成为热门文旅目的地。作为集娱乐、餐饮、购物、研学、演艺于一体的综合性文旅目的地，项目充分满足家庭亲子活动和研学度假的多重需求。项目将持续助力黄石城市旅游和现代服务业升级，为黄石文旅产业发展书写新篇章，成为国家级旅游目的地新地标。\n\n一、恐龙梦工厂\n是以恐龙为主题结合黄石本土文化IP的大型一票制主题乐园。园区拥有30余项大型户外机械游乐设备、大型室内沉浸式数字体验设备、大型室内+户外实景演出和剧场表演，以及各类小型演出和互动秀。\n\n必玩项目：\n1. "星际探险家"穹顶剧场，与拉斯维加斯同款，全球唯一720°LED巨幕影院，2400㎡裸眼3D震撼视效，直径27米，配备可容纳160人的大型升降载人玻璃平台，将游客送至穹顶银幕中心，体验16K超高清宏达视觉盛宴和翱翔银河的沉浸感受。\n2. 全球首创LOVE型过山车"龙翔天际"，与意大利游乐先锋赞培拉联合打造，14层楼垂直俯冲，以100公里时速急速上升下降，扭曲转弯，带游客体验摇摆震动的呼啸之旅。\n3. 全球首创超高银幕内垂直运动体验的高科技娱乐项目"太空电梯-矿井大冒险"，解锁全新电梯跌落体验：20米超高环形银幕环绕轿厢，3D影像沉浸式再现矿井奥秘。10米急速上升过程中，目睹矿井井壁冲天而上的惊险景象；瞬间自由跌落时，失重感与俯冲视觉效果碰撞，每一秒都仿佛要冲破银幕，刺激指数拉满！\n4. 中国首创大型旋转载人动感平台"宝石大劫案"飞行影院，其多维运动机构包括上下、左右、前倾、后仰，完美模拟真实飞行动态。配备直径22米180度半球形LED穹顶银幕呈现超高清视觉，跟随IP角色以第一人称视角进入恐龙世界，开启心跳加速的真实飞行体验。\n\n二、恐龙水世界\n夏日必游的水上乐园项目，拥有数十项国内外顶级水上游乐设施，充分满足家庭和年轻游客对欢乐刺激水世界体验的渴望。800米长的环园懒人河，华中最大的8000余平米恐龙主题造浪池，震撼进口滑道眼镜蛇、龙卷风喇叭、巨兽碗，以及中国首创电磁弹射双轨水上过山车，还有时光隧道、龙门水寨、飞毯、大黄蜂滑道等，从高速刺激到悠闲戏水，应有尽有。\n\n必玩项目：\n1. 华中最大龙王造浪池，占地8000平米，持续产生3米高巨浪，模拟汹涌海洋。夜幕降临，造浪池伴随雷鸣般的轰鸣声，五只巨型机械恐龙突然"苏醒"，双眼发出红光，在云雾缭绕中向人群"喷火"，营造出尖叫、欢笑与海浪交织的沉浸式欢乐永不停歇！\n2. "双轨水上过山车"——采用先进电磁弹射技术，水上过山车实现15米落差，速度高达11m/s，挑战重力的凌空速度感。\n3. 龙卷风喇叭从六层楼高度跌落，游客经历20米跌落进入巨型风暴漏斗，翻滚旋转的冒险之旅。\n4. 眼镜蛇滑道采用逼真巨蛇造型，从18米高处几乎垂直俯冲，速度达12m/s，惊险模拟从蛇口逃生，视觉和身体冲击强烈。',
    trafficInfo: {
      huangshiStation: '【黄石站】22路转35路，黄石火车站上车，矿博园站下车',
      huangshiNorthStation: '【黄石北站】轨道交通一号线，黄石北站上车，矿博园站下车',
      dayeNorthStation: '【大冶北站】32路转35路 / 55路 或 42路转35路，大冶北站上车，矿博园站下车',
      hotels: '【住宿】格兰云天酒店、希尔顿花园酒店'
    },
    foodAndShoppingInfo: '恐龙梦工厂：翼龙杂货铺、矿龙列车烧烤长廊、暴龙汉堡、魔法补给站、龙妈餐厅、星际能源补给站、飞翼咖啡屋、吾饮良品、宝藏屋、晶能宝屋、星愿小屋、晶能礼品屋、桥头排骨、龙茶、龙域百货<br>' +
        '恐龙水世界：暴走的汉堡、干饭龙餐厅、锦鲤水吧、萌龙食屋、能量披萨、火辣派对、凉凉冰室、寻龙食客、酷脉、恐龙士多店<br>' +
        '恐龙潮玩馆：云上咖啡、烟火市集<br>' +
        '恐龙小镇：全球美食荟、恐龙礼品店'
  },
  scenic: {
    title: '缤纷景区',
    waterWorld: '恐龙水世界',
    landWorld: '恐龙陆地世界',
    introText: {
      part1: '作为华侨城集团旗下品牌产品，黄石华侨城卡乐文化旅游项目位于黄石市大冶湖畔，按国家5A级景区标准建设。项目总体规划面积1800亩，总投资30亿元，以"文化+旅游+科技+研学+生态"为基本元素，以侏罗纪恐龙世界为蓝本匠心打造的文化主题旅游度假目的地。',
      part2: '一期建设恐龙水世界将声光电科技、影视特效与多媒体网络等完美结合，融展示、科普、娱乐及参与性表演于一体的戏水主题乐园。游客可以在此领略浪花冲击的无限快感；享受侏罗纪丛林的神秘惊奇；感受徜徉溪流的美妙乐趣；更可以欣赏充满异域风情的精彩演绎。恐龙水世界为您倾力打造全新的玩水乐园，带您尽享酷爽激情。'
    },
    attractions: {
      wavePool: '造浪池',
      dragonCastle: '龙门水寨',
      doubleCoaster: '水上过山车',
      greedyDragon: '贪吃龙滑道',
      sleepingDragon: '卧龙滑道',
      timeLight: '时光隧道',
      wildRiver: '激情水上漂',
      cobraSlide: '眼镜蛇滑道',
      monsterBowl: '巨兽碗',
      babyPool: '萌龙戏水池',
      speedSlide: '极速滑道',
      familySlide: '合家欢滑道',
      carpetBee: '大黄蜂',
      // 陆地项目
      gemHeist: '宝石大劫案',
      trexRacing: '暴龙赛车',
      birthdayParty: '爆笑生日趴',
      centrifuge: '欢乐离心机',
      crystalGuards: '晶能护卫队',
      crystalTornado: '晶能旋风',
      monsterChase: '巨兽追击',
      mineAdventure: '矿井大冒险',
      mineDragonCave: '矿龙迷窟',
      mineDragon: '矿山飞龙',
      skyDragon: '龙翔天际',
      horseTraining: '马术训练营',
      dreamBalloon: '梦幻热气球',
      magicSpin: '魔力转圈圈',
      jumpingDragon: '魔头跳跳龙',
      policeBase: '特警龙基地',
      sweetCannon: '甜蜜礼炮',
      spaceExplorer: '星际探险家',
      iceCreamCone: '旋转雪糕筒',
      superCrisis: '异能危机',
      galaxyPirate: '银河海盗船',
      cloudWalker: '云端漫步车'
    },
    descriptions: {
      imageAlt: '项目图片',
      wavePool: '黄石乃至华中地区水域面积超大、造浪超高的"真空造浪池"，水面积占地8000平米，浪高3米的大海啸巨浪从不同方向冲击水岸，海浪波涛汹涌，将阵阵清凉袭卷而来，让游客全方位享受浪花冲击、自由潜浮时的无限快感。',
      // 陆地项目描述
      gemHeist: '世界主流黑暗乘骑产品，为第四代沉浸式主题乐园明星项目，其运动速度高达2.74米每秒，车体六自由度+360度旋转。需佩戴3D立体眼镜，按照既定的故事线，穿梭于变化多样的虚实结合场景内，体验一场惊险刺激的探险之旅。',
      trexRacing: '列车动力提升到轨道最高端后，立即转为沿轨道自由高速滑行，时而攀升翻滚，时而俯冲直下，时而螺旋穿梭，风驰电掣，呼啸而行。尽情地领略失重、倒转和离心的强烈感觉，惊险刺激。',
      birthdayParty: '体验爆笑两姐妹的快乐生日趴；世界主流的互动脱口秀剧场项目，采用超清LED屏，结合幻影成像、同步影音播放、人机虚拟交互、实景机模等技术，以虚拟卡通角色与观众进行知识问答、互动游戏的方式，生动演绎趣味搞笑的脱口秀表演。',
      centrifuge: '欢乐离心机是一种组合运动型大型游乐设备，为挑战者之旅游艺机的第四代产品。该设备的基本动作是：在乘人座舱绕摆臂做圆周旋转的同时，摆臂带动座舱往复摆动，随着摆动次数的增加，整个乘人座舱被越摆越高，直至摆落设定的高位。乘客在这一次次的摆动过程中，时而感觉冲上云霄，时而感觉被甩入谷底，仿佛置身于茫茫宇宙，天旋地转，感受无穷无尽的刺激。',
      crystalGuards: '世界一流、国内领先的全新抓举式动感车体验项目，其载人平台的翻转、晃动、360°旋转等体感动作，能完美呈现行走式飞行的体验效果，结合形状各异的超大球幕、双曲幕呈现的多维度影视表演，使游客体验一场凌空飞翔的极速穿行之旅。',
      crystalTornado: '游客乘坐在圆盘形座舱上，座舱绕摆臂做圆周旋转的同时，随摆臂做往复摆动。在运行过程中，游客时而感觉冲上云霄，时而感觉被甩入谷底，仿佛置身于茫茫宇宙，天旋地转，感受无穷无尽的刺激。',
      monsterChase: '世界一流、国内领先的沉浸式动感巴士项目，车体采用大型六自由度平台，能最大幅度的模拟撞击、提升、下落、震动等体感效果，车体可360°旋转，配备920平米全环绕巨型双曲幕带来的4K影视画面，模拟穿梭于各种奇幻场景，尽情享受震撼的视觉及体感冲击。',
      mineAdventure: '体验失重与超重的影视电梯，全球首创在超高银幕内垂直运动体验的高科技娱乐项目。20米超高环形巨幕，载人轿厢行程达10米，上升/下降速度可达2m/s，加速度达3.2m/s。急速提升和降落与3D影视画面的对冲结合，可连续体验身体失重的刺激感受。',
      mineDragonCave: '"吓破胆、腿发软"鬼屋惊魂记，集娱乐性、竞技性、社交性、互动性于一体的新型高科技互动鬼屋。项目以恐怖、刺激、紧迫、动静结合为体验特点，结合真人NPC、机械、实景装饰以及影视特技等手段，在恐怖主题空间中获得视、听、触等多重感官的惊悚体验。',
      mineDragon: '体验飞驰在"山路十八弯"上的快感，列车时而攀升翻滚，时而俯冲直下，时而螺旋穿梭，风驰电掣，呼啸而行。坐在座椅上，尽情地领略失重、倒转和离心的强烈感觉，惊险刺激。',
      skyDragon: '全球首创"LOVE型"轨道过山车龙翔天际，以98kmh速度急速上升、下降，经历各种扭曲和转弯，体验摇摆和震动的呼啸之旅。',
      horseTraining: '在动听的音乐中，坐上飞马纵情驰骋梦幻间，体验卡乐星球史上最奇妙的旋转。',
      dreamBalloon: '6米摩天轮不仅性能优越、操作简单、方便可靠，6个独立的座舱造型新颖、灯光华丽，配上动听的音乐，深受广大儿童游客的欢迎。',
      magicSpin: '躺在旋转簸箕里的小豆子，谁会是第一个被抖出局的呢；躺在中央，感受到颠簸、旋转，带来无限的乐趣，同时，又让人回味无穷。',
      jumpingDragon: '波澜起伏的弹跳车深受亲子家庭的喜爱，亲子之间互动性较强，深受各年龄段儿童的欢迎，为亲子家庭带来高质量的陪伴。',
      policeBase: '由攀爬、滑行、钻筒、走梯等功能组成的游乐无动力设施，具有社交性强、互动性强、合作性强、激发竞争意识、亲子同乐和创意无限等特点，是亲子互动的利器。',
      sweetCannon: '甜蜜礼炮是一种飞行塔类探空飞梭系列A级游乐设备，是乘人的升降车沿着立轨道作上升、下降和连贯的垂直运动的游乐设备。乘客在极短的时间内被发射至主立架约44米高度，紧接着在重力作用下疾速跌落，然后再次被空气压力弹回至主立架中部偏上位置，最后按照预设程序慢慢下降，安全返回地面。',
      spaceExplorer: '全球唯一720°超大球型LED影院剧场，可视面积达2400平米，直径达28米，配有可容纳160人的大型升降载人玻璃平台，将游客送至球幕中心，体验高达16K超高清的宏达视觉盛宴。',
      iceCreamCone: '"低空飞翔"的旋转木马，集旋转、升降、变倾角等多种运动形式于一体的飞行塔，当塔徐徐上升，转盘摇动，飞椅呈波浪荡漾状，犹如在空中飞翔、飘荡。',
      superCrisis: '"多维动感乘骑"采用自主研发的自带动力轨道车，全程由高速滑触线供电，在管轨式轨道上按照项目需求，不断变速行驶，依次经过六自由度、提升机构、断轨装置、弹射机构、跷跷板装置等五大特技区域，其中，既有过山车式的高速俯冲、上升体验，又有特技区域带来的提升、跌落、加速弹射等不同体验，再配以观影巨幕和精彩影视内容，带给游客一段惊险、刺激不断的独特游玩经历。',
      galaxyPirate: '体验巨浪中跌宕摇摆的巨型秋千；坐在海盗船上绕水平轴来回摆动，此起彼伏，交替而至的失重和超重感受，带来无限的惊险、刺激，又让人回味无穷。',
      cloudWalker: '悠闲穿行于云端的观光小火车；又称为高空观览车、亲子活动车，是一种创意新颖的架空游览车，一边同亲友闲聊，一边饱览美景。',
      dragonCastle: '老少皆宜，合家共享；风格主题多样设计，集水滑梯、各类喷头装置、互动戏水项目于一体并结合各种雕塑造型，不同高度的体验平台通过楼梯、网桥、攀爬网、隧道等融合联通,轻松实现滑水、冲淋、攀爬等各类体验需求。酣畅淋漓，全家共享。',
      doubleCoaster: '置身敞开式的蓝色滑道，伴随3、2、1的倒数似离弦之箭沿着水上滑梯急速俯冲、动感滑行，上下翻腾如过山车般极速前进，突破飞溅激流和汹涌浪花的激爽让人直呼过瘾。',
      greedyDragon: '"贪吃龙滑道"由三条滑道组成，分别为高速滑道、变坡滑道、螺旋冲刺的人体直滑项目。是专为热爱冒险的勇敢者们设计的系列产品，伴随脚下突然悬空，继而跌落入几乎垂直的滑行面下冲，在无依托滑道中穿越，惊魂未定之时急转弯跌入落水池中，感受黑暗中的速度与激情，体验安全无忧的极限运动。',
      sleepingDragon: '色彩斑斓的流光溢彩映入眼帘，密闭式，敞开式滑道蜿蜒交错，堪称现实版的欢乐梦工厂。不仅可以极速盘旋，也可以温柔滑行，满足各个年龄段的速度要求。从高高的平台上俯冲而下，途中左旋右转，或急速下降，或惊险刺激，适合与水来一次亲密的接触。',
      timeLight: '乐园独家引进水上奇幻体验项目"时空潜行"，缤纷滑道镶嵌形态各异的光圈和星点光束，让人置身如梦似幻的时光隧道。游客在接受惊险刺激洗礼的同时，也可以让眼睛来一场目不暇接的时空旅行！亦真亦幻的奇妙世界，等您来发现。',
      wildRiver: '近千米长休闲懒人河，是华中独具特色的人工漂流河，平躺在特别设计的浮圈之上随波漂流，悠然自得地饱览丛林风光，领略神秘新奇的异域风情，尽情享受徜徉溪流的美妙乐趣。漂流过程还可与岸边游客喷射戏水，激情互动，在惊喜挑战中感受奇幻神秘的亲水之旅。',
      cobraSlide: '眼镜王蛇"来啦，张狂地龇牙咧嘴盘踞水上乐园之上；滑道效果巧妙融合眼镜蛇外观，螺旋部分犹如蛇身蜷缩，蛇口位置正吐着危险信子等待游客前来探险。从平台出发，经过蜿蜒曲折的螺旋滑道高速进入蛇口，最后回旋喷出进入水池，强烈的视觉冲击力及超强体验感势必能为游客带来前所未有的激情享受。',
      monsterBowl: '形如飓风、大若巨碗，强烈的视觉冲击是它们的专属标签。您将乘坐四叶草形浮圈，从六层楼高的平台开始滑行，飞一般冲入巨大的喇叭形滑道，如同被龙卷风吞没般螺旋下降，在极速穿行中惊声尖叫，欢乐的呼喊响彻乐园。如此热情澎湃的新奇快感，不可错过。',
      babyPool: '专属宝娃的戏水乐园，各式迷你可爱的水上滑道让宝娃自由穿行，匹配儿童身高的浅水池，让宝娃安全自在地与水嬉戏，尽情释放童心。色彩斑斓的亲子滑道巧妙地改变滑行轨迹，为每个亲子家庭提供一段奇妙的滑行之旅。',
      speedSlide: '颠覆传统，"疾速滑道"将带给游客倒立滑行的全新体验。游客高速环滑在五颜六色管状滑道，经历360度天旋地转，继而沿着色彩斑斓的滑梯急速坠落，穿越一系列的 "驼峰"起伏终于到达终点。独具竞技特性让游客欲罢不能，谁能在激爽刺激的游戏中拔得头筹，我们一起拭目以待！',
      familySlide: '想要全家人一起来场惊险刺激的酷爽之旅，"合家欢滑道"可以了解下！6人皮筏可轻松装载全家人的欢乐梦想；彼此手挽手肩并肩从18m高台喷涌而下，伴随一路尖叫自由穿行在蜿蜒起伏的滑道之中，合家欢乐的幸福时刻就此开启！',
      carpetBee: '游客将乘坐专用皮筏，从20m高平台下滑，如同太空飞船般俯冲而下，踏着旋风巨浪的浪尖在滑道中划出优美的弧线，体验"漂移"的快感；惊魂未定时，又在自身重力作用下快速进入曲折回环的蛇形滑道，最终经过多角度急转弯跌入落水池，这种天旋地转的晕眩将让您永生难忘。'
    }
  },
  contact: {
    title: '联系我们',
    address: '地址',
    phone: '电话',
    email: '邮箱'
  },
  language: {
    zh: '中文',
    en: '英文'
  },
  news: {
    parkDynamics: '景区动态',
    newsInfo: '新闻资讯',
    parkDynamicsItems: [
      { 
        title: '好绝！年卡免费送！2025《恐怖剧本高阶玩法》来了~', 
        date: '2025.10.24'
      },
      { 
        title: '今天有一件大事宣布！！恐龙奇域中秋夜场福利上线！', 
        date: '2025.10.05'
      },
      { 
        title: '很重要！连续8天！每日50+场演出，沉浸式游乐焕新体验！国庆节目单重磅出炉', 
        date: '2025.09.29'
      },
      { 
        title: '教师节宠粉！请您免费玩转恐龙奇域！', 
        date: '2025.09.05'
      },
      { 
        title: '周六日晚8点烟花盛宴 | 双园日夜不限次畅玩，快乐不止亿点点', 
        date: '2025.07.12'
      },
      { 
        title: '六一儿童节，我只带娃去一个地方：恐龙奇域', 
        date: '2025.05.31'
      },
      { 
        title: '五一奇域·魔幻亲子艺术节来啦！轻松遛娃，看这篇就够！', 
        date: '2025.04.28'
      },
      { 
        title: '鲜花免费送！10万+盆鲜花浪漫邂逅"恐龙奇域花仙艺术节"限时春日花海！4月3日开启赏花盛宴！', 
        date: '2025.04.01'
      },
    ],
    newsInfoItems: [
      { 
        title: '台湾选手打卡黄石恐龙奇域：赞科技魅力 叹转型经验', 
        date: '2025.11.03'
      },
      { 
        title: '延时提醒：今晚来这嗨到21点', 
        date: '2025.10.31'
      },
      { 
        title: '重要提醒：今晚开启疯玩模式！限定5天！加倍加时狂欢！', 
        date: '2025.10.25'
      },
      { 
        title: '@所有人，恐龙奇域限时免费入园！', 
        date: '2025.10.17'
      },
      { 
        title: '湖北超级文旅日免票优惠攻略！17号生日免费玩！', 
        date: '2025.10.13'
      },
      { 
        title: '重要变化！运营时间调整', 
        date: '2025.10.08'
      },
      { 
        title: '国庆还在挤武汉的人亏大了！恐龙奇域花车狂欢，全天11小时50+演出一站嗨玩到底！', 
        date: '2025.10.03'
      },
      { 
        title: '边玩边「赚钱」？！这个国庆假期，恐龙奇域搞钱、搞快乐！！！', 
        date: '2025.10.01'
      },
      { 
        title: '全球TOP级！谁来挑战？！', 
        date: '2025.09.14'
      },
      { 
        title: '恐龙奇域亮相 2025 武汉文博会 黄石文旅新地标引关注', 
        date: '2025.09.13'
      },
      { 
        title: '马上放假！！！', 
        date: '2025.09.09'
      },
      { 
        title: '大学生开学第一课：如何省钱？', 
        date: '2025.09.03'
      },
      { 
        title: '急急急！全网捞人！我们需要20名NPC！', 
        date: '2025.09.01'
      },
      { 
        title: '重要提醒！运营时间有变动！！水世界暂时告别，梦工厂精彩继续！', 
        date: '2025.08.31'
      },
      { 
        title: '我很少用"震撼"来形容一个地方…', 
        date: '2025.06.18'
      },
      { 
        title: '最后7天！我们决定门票全免！', 
        date: '2025.04.07'
      },
    ]
  },
}